module.exports = __webpack_public_path__ + "static/media/icon_close.112a2e89.svg";